import { render } from "./WLabsLogo.vue?vue&type=template&id=c17e5882&scoped=true"
import script from "./WLabsLogo.vue?vue&type=script&lang=js"
export * from "./WLabsLogo.vue?vue&type=script&lang=js"

import "./WLabsLogo.vue?vue&type=style&index=0&id=c17e5882&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c17e5882"]])

export default __exports__